import { render, staticRenderFns } from "./purchasingIncomingStockWidget.vue?vue&type=template&id=1b4d41af&"
import script from "./purchasingIncomingStockWidget.vue?vue&type=script&lang=js&"
export * from "./purchasingIncomingStockWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports